<template>
  <v-row no-gutters :style="'justify-content:' + colsAlign">
    <!-- Front SVG / Skeleton -->
    <v-col :cols="cols">
      <v-skeleton-loader v-if="!frontReady" type="image" :style="'height:' + height" style="width: 100%"></v-skeleton-loader>
      <object
        class="interactive-human-body__svg"
        :class="margin"
        :style="{ height: frontReady ? height : '0px', background: background, borderRadius: borderRadius, opacity: frontReady ? 1 : 0 }"
        @load="frontInit"
        :id="'front' + split"
        type="image/svg+xml"
        data="/img/einmalig/humanSVGFrontPlanRun.svg"></object>
    </v-col>

    <!-- Back SVG / Skeleton -->
    <v-col :cols="cols">
      <v-skeleton-loader v-if="!backReady" type="image" :style="'height:' + height" style="width: 100%"></v-skeleton-loader>
      <object
        :id="'back' + split"
        :class="margin"
        :style="{ height: backReady ? height : '0px', background: background, borderRadius: borderRadius, opacity: backReady ? 1 : 0 }"
        class="interactive-human-body__svg"
        type="image/svg+xml"
        @load="backInit"
        data="/img/einmalig/humanSVGBackPlanRun.svg"></object>
    </v-col

    <!-- Tag Windows bleiben unverändert -->
    <v-col cols="12" v-if="!hideTagWindows">
      <v-window v-model="tagWindows">
        <v-window-item v-for="activeClass of activeClasses" :value="activeClass" :key="`card-${activeClass}`">
          <v-card color="#f5f5f5" class="rounded-xl ma-5">
            <v-card-title v-if="tags.find((filter) => filter.class === activeClass)">
              {{ tags.find((filter) => filter.class === activeClass).name }}
              <v-chip class="ml-2">
                {{ getExercisesByTag(activeClass).length + (getExercisesByTag(activeClass).length > 1 ? " Übungen" : " Übung") }}
              </v-chip>
            </v-card-title>
            <v-row no-gutters style="max-height: 200px; overflow: auto">
              <v-col class="pa-3" cols="12" v-for="(exercise, index) of getExercisesByTag(activeClass)" :key="'workoutEx' + index">
                <div style="display: flex">
                  <v-col cols="3">
                    <v-img class="rounded" :src="exercise.img"></v-img>
                  </v-col>
                  <v-col cols="9">
                    <v-card-title class="h6 py-1">{{ exercise.title }}</v-card-title>
                    <v-card-subtitle class="py-1">{{ exercise.device }}</v-card-subtitle>
                  </v-col>
                </div>
                <v-divider class="my-0"></v-divider>
              </v-col>
            </v-row>
          </v-card>
        </v-window-item>
      </v-window>
    </v-col>
  </v-row>
</template>

<script>
import VueFlip from "vue-flip"
import api from "@/api"
import userService from "@/services/userService"
import { mapGetters, mapActions } from "vuex"
import { create } from "@lottiefiles/lottie-interactivity"

export default {
  name: "interactiveHumanBody",
  components: {
    VueFlip,
  },
  props: {
    noTouch: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: "230px",
    },
    updateInComponent: {
      type: Boolean,
      default: false,
    },
    cols: {
      type: [Number, String],
      default: 6,
    },
    background: {
      type: String,
      default: "white",
    },
    borderRadius: {
      type: String,
      default: "0px",
    },
    margin: {
      type: String,
      default: "mx-0",
    },
    colsAlign: {
      type: [Number, String],
      default: "justify-space-around",
    },
    exercises: {},
    split: {
      type: Number,
      default: 0,
    },
    activeClasses: {
      type: Array,
      default: () => [],
    },
    hideTagWindows: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tagWindows: null,
      flipped: false,
      dialog: true,
      tags: [],
      filters: [],
      turnLogoAnimation: null,
      healthIconActive: false,
      stretchIconActive: false,
      stretchAnimation: null,
      stretchWhiteAnimation: null,
      initDone: false,
      navBarInit: false,
      activeElement: null,
      frontReady: false, // Status für vordere SVG
      backReady: false, // Status für hintere SVG
    }
  },
  async created() {
    this.filters = this.activeClasses
    if (this.activeClasses?.length) {
      this.tagWindows = this.activeClasses[0].class
    }
    this.tags = await api.fetchExerciseTags()

    if (this.tags.length && this.filters.length && !this.tags.find(tag => tag.class === this.filters[0])) {
      this.filters = this.filters.map((filter) => {
        const tag = this.tags.find(tag => tag.name === filter)
        if (tag) return tag.class
        return null
      }).filter(filter => filter !== null)
    }
  },
  methods: {
    getExercisesByTag(tag) {
      return this.exercises.filter((exercise) => {
        return exercise.tags.find((exTag) => exTag.class === tag)
      })
    },

    // Angepasste Methode für die vordere SVG
    frontInit(e) {
      console.log('hoi')
      setTimeout(() => {

        const frontSVG = document.getElementById("front" + this.split).getSVGDocument()
        const backSVG = document.getElementById("back" + this.split).getSVGDocument()

        if (!this.initDone && this.filters?.length) {
          this.filters.forEach((filter) => {
            let allElements = [...frontSVG.getElementsByClassName(filter), ...backSVG.getElementsByClassName(filter)]
            // Markiere alle Elemente als "red"
            for (let element of allElements) {
              element.setAttribute("fill", "red")
            }
          })
        }
        this.frontReady = true
        this.backReady = true
        this.initDone = true
        if (this.noTouch) return
        frontSVG.addEventListener("click", (e) => {
          e.target.classList.forEach((klasse) => {
            if (klasse !== "unselectable" && klasse !== "seitliche-schulter") {
              let allElements = [...frontSVG.getElementsByClassName(klasse), ...backSVG.getElementsByClassName(klasse)]
              let color = "gold"
              // Setze alle Filter wieder auf "red"
              this.filters.forEach((filter) => {
                let existingElements = [...frontSVG.getElementsByClassName(filter), ...backSVG.getElementsByClassName(filter)]
                for (let element of existingElements) {
                  element.setAttribute("fill", "red")
                }
              })
              this.tagWindows = klasse
              let error = false
              for (let element of allElements) {
                let existingColor = element.getAttribute("fill")
                if (this.updateInComponent && (!existingColor || existingColor !== "red")) {
                  // Hier wird die Farbe auf "red" gesetzt, wenn sie nicht "red" oder "gold" ist
                  element.setAttribute("fill", "red")
                  this.$emit('addElement', this.tags.find(tag => tag.class ===element.classList[0]).name)
                  this.filters.push(element.classList[0])
                } else if (existingColor === 'red' && this.updateInComponent) {
                  element.setAttribute("fill", "white")
                  this.$emit('removeElement', this.tags.find(tag => tag.class ===element.classList[0]).name)
                  this.filters = this.filters.filter((filter) => filter !== element.classList[0])
                }

                else if (existingColor !== "red" && existingColor !== "gold") {
                  error = true
                } else {
                  // Zum Beispiel: Elemente clonen (falls benötigt)
                  self.activeElements = JSON.parse(JSON.stringify(allElements))
                  element.setAttribute("fill", color)
                }
              }

              if (error && !this.updateInComponent) this.$toast.error("Keine Übungen zu dieser Muskelgruppe gefunden.")
            }
          })
        })
      }, 1000) // Verzögerung, um sicherzustellen, dass die Elemente im SVG bereit sind
    },

    // Angepasste Methode für die hintere SVG
    backInit(e) {
      if (this.noTouch) return
      setTimeout(() => {
        const frontSVG = document.getElementById("front" + this.split).getSVGDocument()
        const backSVG = document.getElementById("back" + this.split).getSVGDocument()
        backSVG.addEventListener("click", (e) => {
          e.target.classList.forEach((klasse) => {
            if (klasse !== "unselectable" && klasse !== "seitliche-schulter") {
              let allElements = [...frontSVG.getElementsByClassName(klasse), ...backSVG.getElementsByClassName(klasse)]
              this.filters.forEach((filter) => {
                let existingElements = [...frontSVG.getElementsByClassName(filter), ...backSVG.getElementsByClassName(filter)]
                for (let element of existingElements) {
                  element.setAttribute("fill", "red")
                }
              })
              this.tagWindows = klasse
              let color = "gold"
              let error = false
              for (let element of allElements) {
                let existingColor = element.getAttribute("fill")

                if (this.updateInComponent && (!existingColor || existingColor !== "red")) {
                  // Hier wird die Farbe auf "red" gesetzt, wenn sie nicht "red" oder "gold" ist
                  element.setAttribute("fill", "red")
                  console.log(element.classList[0])
                  this.$emit('addElement', this.tags.find(tag => tag.class ===element.classList[0]).name)
                  this.filters.push(element.classList[0])

                } else if (existingColor === 'red' && this.updateInComponent) {
                  element.setAttribute("fill", "white")
                  this.$emit('removeElement', this.tags.find(tag => tag.class ===element.classList[0]).name)
                  this.filters = this.filters.filter((filter) => filter !== element.classList[0])

                }
                else if (existingColor !== "red" && existingColor !== "gold") {
                  error = true
                } else {
                  // Zum Beispiel: Elemente clonen (falls benötigt)
                  self.activeElements = JSON.parse(JSON.stringify(allElements))
                  element.setAttribute("fill", color)
                }
              if (error && !this.updateInComponent) this.$toast.error("Keine Übungen zu dieser Muskelgruppe gefunden.")
              }

            }
          })
        })
      }, 1000)
    },
  },
  computed: {
    getSelectedTags() {
      let allActiveClasses = JSON.parse(JSON.stringify(this.activeClasses))
      if (allActiveClasses.includes("vordere-schulter") || allActiveClasses.includes("hintere-schulter")) allActiveClasses.push("seitliche-schulter")
      let filteredTags = this.tags.filter((tag) => allActiveClasses.includes(tag.class))
      return filteredTags
    },
  },
  watch: {
    filters(newValue) {
      this.$emit("filters", newValue)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-dialog {
  background: white;
}
.unselectable {
  fill: white;
}

.interactive-human-body {
  &__flip {
    position: relative;
  }
  &__svg {
    width: 100%;
    height: 100%;
  }
}
</style>
